import React, { ReactNode } from "react";
import { Heading, List } from "@chakra-ui/react";

type ProgressListProps = {
  title: string;
  children: ReactNode;
};

export const ProgressList = ({ title, children }: ProgressListProps) => (
  <div>
    <Heading mb="2" size="sm">
      {title}
    </Heading>
    <List spacing="1">{children}</List>
  </div>
);
